import type { BlogPostViewModel } from "./types";

export function getBlogPrimaryImage(post: BlogPostViewModel): string | undefined {
  return post.coverImageSmallUrl || post.coverImageUrl;
}

export function blogMatchesSelectedTag(post: BlogPostViewModel, selectedTag: string, allTag: string): boolean {
  if (selectedTag === allTag) return true;
  return Boolean(post.tags?.some((tag) => tag.name.toLowerCase() === selectedTag));
}

export function blogMatchesSearchQuery(post: BlogPostViewModel, query: string): boolean {
  if (!query) return true;
  return (
    post.title.toLowerCase().includes(query) ||
    post.excerpt.toLowerCase().includes(query) ||
    Boolean(post.tags?.some((tag) => tag.name.toLowerCase().includes(query)))
  );
}

export interface TocItem {
  id: string;
  text: string;
  level: number;
}

export function slugifyHeading(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

export function extractMarkdownToc(markdown: string): TocItem[] {
  if (!markdown) return [];
  const lines = markdown.split("\n");
  const headings: TocItem[] = [];

  for (const line of lines) {
    const match = /^(#{2,3})\s+(.+)$/.exec(line.trim());
    if (!match) continue;
    const level = match[1].length;
    const text = match[2].trim();
    headings.push({
      id: slugifyHeading(text),
      text,
      level,
    });
  }

  return headings;
}

